import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AddressEditComponent } from 'app/common/address/address-edit.component';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { AddressType, Country } from 'app/profile/models/masterdata.model';
import { OnboardingDocument } from 'app/profile/models/onboarding.model';
import { SupplierAddress } from 'app/profile/models/supplier.model';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { OnboardingState } from 'app/profile/store/state/onboarding.state';
import * as LoaderActions from "../../../../../shared/store/actions/loader.actions";
import { Observable, of } from 'rxjs';
import { TslDialog, TslToastrService } from '@tesla/ng-tds';
import { AddressSuggestionComponent } from 'app/shared/components/address-suggestion/address-suggestion.component';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
  selector: 'app-address-task-dialog',
  templateUrl: './address-task-dialog.component.html',
  styleUrls: ['./address-task-dialog.component.scss']
})
export class AddressTaskDialogComponent implements OnInit {

  @ViewChild('addressEdit', { static: false }) addressEditComponent: AddressEditComponent;

  supplierCode: string;
  requiredDocuments: OnboardingDocument[];
  supplierAddress: SupplierAddress;
  addressTypes$: Observable<AddressType[]>;
  countries: Country[];
  supplierAddressType: string;
  settings$: Observable<GeneralSettings>;
  hideContactDocumentSection: boolean;
  isReactivation: boolean;
  readOnly: boolean;

  constructor(
    public dialogRef: MatDialogRef<AddressTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private supplierStateService: SupplierStateService,
    private onboardingStore: Store<OnboardingState>,
    private tslDialog: TslDialog,
    private toaster: TslToastrService,
    private translate: I18nService,
  ) { }

  ngOnInit(): void {
    if(this.data) {
      this.supplierCode = this.data?.supplierCode;
      this.requiredDocuments = this.data?.requiredDocuments;
      this.supplierAddress = this.data?.supplierAddress;
      this.addressTypes$ = this.data?.addressTypes$;
      this.countries = this.data?.countries;
      this.supplierAddressType = this.data?.supplierAddressType;
      this.settings$ = this.data?.settings$;
      this.hideContactDocumentSection = this.data?.hideContactDocumentSection;
      this.isReactivation = this.data?.isReactivation;
      this.readOnly = this.data?.readOnly;
    }
  }

  setErrorMessage(message) {
    if (message) this.toaster.error((message && message.trim() != '') ? message : this.translate.get('Something went wrong!'))
  }

  addressFormSubmit(supplierAddress: SupplierAddress) {
    // if(this.isReactivation && this.isAddressEdit && this.selectedIndex > -1 && this.selectedIndex < this.existingItemList?.length) {
    //   supplierAddress.ID = this.existingItemList[this.selectedIndex].ID;
    //   supplierAddress.Operation = OPERATION.UPDATE;
    // }
    //  If country is US, we fetch address predictions
    if (supplierAddress.CountryCode == 'US') {
      this.supplierStateService.getPredictions(supplierAddress)

        //  1. Get address predictions and return the selected address if any
        .mergeMap(predictions => this.requestUserToSelectPrediction(predictions, supplierAddress))

        //  2. Use action to send POST request to save address
        .subscribe(address => {
          this.supplierAddress = address;
          //  Dispatch action to save the supplier address
          this.dialogRef.close(address);
        });

    } else {
      //  We don't need to fetch address predictions
      this.dialogRef.close(supplierAddress);
    }
  }

  private requestUserToSelectPrediction(predictions: any[], supplierAddress: SupplierAddress): Observable<SupplierAddress> {
    this.onboardingStore.dispatch(new LoaderActions.DecrementLoaderCount());    //  Hide spinner

    if (predictions && predictions.length > 0) {

      let completeAddress = supplierAddress.Street1 + ", " +
        supplierAddress.City + ", " +
        (supplierAddress.State ? supplierAddress.State : "") + " " +
        supplierAddress.ZipCode + ", " +
        this.countries.find(x => x.abbreviation === supplierAddress.CountryCode)?.name;

      if (predictions.findIndex(r => r === completeAddress) < 0) {

        //  The user entered an address that is not equal to any of the predictions,
        //  Open suggetion dialog to let the user select one of the predictions
        const dialogRef = this.tslDialog.open(AddressSuggestionComponent, {
          minWidth: '500px',
          data: predictions
        });

        //  Wait until the dialog is closed with the selected prediction
        return dialogRef.afterClosed().map((selectedAddress: SupplierAddress) => {

          //  Update the supplier address to have the data of the address
          //  that the user selected in the pop up dialog.
          if (selectedAddress) {
            supplierAddress = {
              ...supplierAddress,
              CountryCode: selectedAddress.CountryCode,
              Street1: selectedAddress.Street1,
              City: selectedAddress.City,
              State: selectedAddress.State,
              ZipCode: selectedAddress.ZipCode
            };
          }
          return supplierAddress;
        });
      } else {

        //  The Input Address is already in the collection of predictions,
        //  we dont' need the user to select a prediction.
        //  Use the address
        return of(supplierAddress);
      }
    } else {
      //  We don't have predictions for the input address
      //  Use the address as it is
      return of(supplierAddress);
    }
  }

  onSubmit() {
    this.addressEditComponent.submit();
  }

  onClose() {
    this.dialogRef.close();
  }
}
